import React, { useState } from "react";
import UserContext from "./UserContext";

const UserContextProvider = ({ children }) => {
  const [isUserExist, setIsUserExist] = useState(true);
  return (
    <UserContext.Provider value={{ isUserExist, setIsUserExist }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
